// const accessToken = sessionStorage.getItem('access_token');
const state = {
  config: null,
  token: "",
  // base_url: 'http://3.111.140.40:8001/api/v1/',
  selected_deal_id: null, // to be used in settlement page
  selected_settlement_id: null, // to be used in prefund page
  role_rights: null, // to be used in prefund page
  selectedTabs: {},
};

const mutations = {
  SET_CONFIG(state, data) {
    state.config = data;
  },
  set_token: (state, payload) => {
    state.token = payload;
  },
  set_selected_deal_id: (state, payload) => {
    state.selected_deal_id = payload;
  },
  set_selected_settlement_id: (state, payload) => {
    console.log('Payload:', payload);
    state.selected_settlement_id = payload;
  },
  set_role_rights: (state, payload) => {
    state.role_rights = payload;
  },
  SelectedNavTabs: (state, payload) => {
    Object.assign(state.selectedTabs, payload);
    state.selectedTabs = payload;
  },
};

const actions = {
  setConfig({ commit }, config) {
    commit("SET_CONFIG", config);
  },
  setRoleRights({ commit }, role_rights) {
    commit("set_role_rights", role_rights);
  },
};

export const accessToken = () => {
  let accessToken = state.token;
  console.log("test 1111", accessToken);
  return accessToken;
};

export const app = {
  namespaced: true,
  state,
  mutations,
  actions,
};
